import { Link } from 'react-router';
import { LangSwitch, tr, useLang } from '../i18n';
import { TERMS } from '../legal/terms';
import { ThemeSwitch } from '../ui';

/** Top bar of the public legal pages (terms, accessibility statement). */
export function LegalBar() {
  return (
    <div className="terms-bar">
      <Link to="/" className="terms-brand">ZeroGap</Link>
      <div className="row" style={{ gap: 4 }}>
        <ThemeSwitch className="btn sm ghost" />
        <LangSwitch className="btn sm ghost" />
      </div>
    </div>
  );
}

/** Public page: the terms accepted at sign-up. Shown in the current UI language; Hebrew is binding. */
export function Terms() {
  const { lang } = useLang();
  const doc = TERMS[lang];
  return (
    <div className="terms">
      <LegalBar />
      <article className="terms-body">
        <h1>{doc.title}</h1>
        <p className="muted small">{doc.updated}</p>
        {doc.intro.map((p, i) => <p key={i}>{p}</p>)}
        <nav className="terms-toc" aria-label={tr('Contents')}>
          <ol>
            {doc.sections.map((s, i) => <li key={i}><a href={`#s${i + 1}`}>{s.title}</a></li>)}
          </ol>
        </nav>
        {doc.sections.map((s, i) => (
          <section key={i} id={`s${i + 1}`}>
            <h2><span className="terms-num">{i + 1}.</span> {s.title}</h2>
            {s.clauses.map((c, j) => (
              <div key={j} className="terms-clause">
                <span className="terms-num">{i + 1}.{j + 1}</span>
                <div>
                  {typeof c === 'string' ? c : (
                    <>
                      {c.text}
                      <ul>{c.list.map((l, k) => <li key={k}>{l}</li>)}</ul>
                    </>
                  )}
                </div>
              </div>
            ))}
          </section>
        ))}
      </article>
    </div>
  );
}
